import { Zap, Compass, Sparkles } from "lucide-react";
import { Reveal } from "./Reveal";

const LINES = [
  { icon: Zap, text: "AI accelerates the work." },
  { icon: Compass, text: "Strategy gives it direction." },
  { icon: Sparkles, text: "Creativity makes it matter." },
];

export const AIHuman = () => (
  <section
    data-testid="ai-human-section"
    className="relative py-24 lg:py-32 border-y border-white/[0.05] overflow-hidden"
  >
    <div
      aria-hidden="true"
      className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[300px] bg-[#6D00FF]/8 blur-[160px] rounded-full pointer-events-none"
    />
    <div className="relative max-w-7xl mx-auto px-6 lg:px-8 text-center">
      <Reveal>
        <h2 className="font-display text-4xl sm:text-6xl lg:text-7xl font-extrabold uppercase tracking-tighter leading-[1.0]">
          AI speed. <span className="text-gradient-purple">Human strategy.</span>
        </h2>
      </Reveal>
      <div className="mt-14 flex flex-col sm:flex-row items-center justify-center gap-5 sm:gap-14">
        {LINES.map((l, i) => (
          <Reveal key={l.text} delay={0.15 + i * 0.12}>
            <p
              data-testid={`ai-human-line-${i}`}
              className="flex items-center gap-3 text-sm sm:text-base text-[#A6A6B0]"
            >
              <l.icon className="w-4 h-4 text-[#C43CFF]" strokeWidth={1.5} />
              {l.text}
            </p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
